import { render, staticRenderFns } from "./LastDate.vue?vue&type=template&id=5abd0d4d&scoped=true&"
import script from "./LastDate.vue?vue&type=script&lang=js&"
export * from "./LastDate.vue?vue&type=script&lang=js&"
import style0 from "./LastDate.vue?vue&type=style&index=0&id=5abd0d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd0d4d",
  null
  
)

export default component.exports